module.exports = __webpack_public_path__ + "img/FAP Ligand 2 .f4c6f433.png";